"use strict";
// what provider to prioritize if user has autoselect enabled
Object.defineProperty(exports, "__esModule", { value: true });
exports.PRIORITY_COUNTRIES_SELL = exports.PRIORITY_COUNTRIES_BUY = void 0;
const DEFAULT_BUY_PROVIDER = "banxa";
const DEFAULT_SELL_PROVIDER = "moonpay";
exports.PRIORITY_COUNTRIES_BUY = {
    "DEFAULT": DEFAULT_BUY_PROVIDER,
    // ALCHEMY
    "TH": "alchemy",
    "VN": "alchemy",
    // BANXA
    "AI": "banxa",
    "AR": "banxa",
    "AZ": "banxa",
    "BD": "banxa",
    "BE": "banxa",
    "CV": "banxa",
    "CY": "banxa",
    "ES": "banxa",
    "FO": "banxa",
    "FR": "banxa",
    "GD": "banxa",
    "HK": "banxa",
    "MT": "banxa",
    "NL": "banxa",
    "NO": "banxa",
    "NZ": "banxa",
    "PE": "banxa",
    "PF": "banxa",
    "PK": "banxa",
    "PT": "banxa",
    "UY": "banxa",
    "UZ": "banxa",
    // MERCURYO
    "AE": "mercuryo",
    "AL": "mercuryo",
    "AU": "mercuryo",
    "BG": "mercuryo",
    "BM": "mercuryo",
    "BS": "mercuryo",
    "BW": "mercuryo",
    "BY": "mercuryo",
    "CH": "mercuryo",
    "CW": "mercuryo",
    "DK": "mercuryo",
    "EE": "mercuryo",
    "FI": "mercuryo",
    "FJ": "mercuryo",
    "GH": "mercuryo",
    "HR": "mercuryo",
    "IL": "mercuryo",
    "IT": "mercuryo",
    "JM": "mercuryo",
    "JO": "mercuryo",
    "JP": "mercuryo",
    "KZ": "mercuryo",
    "LA": "mercuryo",
    "LR": "mercuryo",
    "LT": "mercuryo",
    "MK": "mercuryo",
    "MR": "mercuryo",
    "MU": "mercuryo",
    "NA": "mercuryo",
    "OM": "mercuryo",
    "PL": "mercuryo",
    "RU": "mercuryo",
    "SI": "mercuryo",
    "SK": "mercuryo",
    "TR": "mercuryo",
    "UA": "mercuryo",
    "ZA": "mercuryo",
    // MOONPAY
    "AD": "moonpay",
    "AG": "moonpay",
    "AM": "moonpay",
    "AT": "moonpay",
    "BA": "moonpay",
    "BH": "moonpay",
    "BO": "moonpay",
    "BR": "moonpay",
    "BT": "moonpay",
    "CD": "moonpay",
    "CF": "moonpay",
    "CZ": "moonpay",
    "DM": "moonpay",
    "DO": "moonpay",
    "DZ": "moonpay",
    "ET": "moonpay",
    "GB": "moonpay",
    "GE": "moonpay",
    "GM": "moonpay",
    "GR": "moonpay",
    "GT": "moonpay",
    "ID": "moonpay",
    "IE": "moonpay",
    "KE": "moonpay",
    "KW": "moonpay",
    "LC": "moonpay",
    "LK": "moonpay",
    "LV": "moonpay",
    "MD": "moonpay",
    "ME": "moonpay",
    "MV": "moonpay",
    "MZ": "moonpay",
    "NE": "moonpay",
    "NG": "moonpay",
    "PY": "moonpay",
    "QA": "moonpay",
    "RS": "moonpay",
    "RW": "moonpay",
    "SA": "moonpay",
    "SB": "moonpay",
    "SN": "moonpay",
    "SV": "moonpay",
    "TN": "moonpay",
    "TO": "moonpay",
    "TZ": "moonpay",
    "UG": "moonpay",
    "WS": "moonpay",
    "ZM": "moonpay",
    "ZW": "moonpay",
    // SIMPLEX
    "BL": "simplex",
    "EC": "simplex",
    "GQ": "simplex",
    "GY": "simplex",
    "HM": "simplex",
    "IM": "simplex",
    "IQ": "simplex",
    "IR": "simplex",
    "JE": "simplex",
    "KM": "simplex",
    "KR": "simplex",
    "MF": "simplex",
    "MN": "simplex",
    "MO": "simplex",
    "NP": "simplex",
    "SC": "simplex",
    "SH": "simplex",
    "SL": "simplex",
    "ST": "simplex",
    "SZ": "simplex",
    "TT": "simplex",
    "TW": "simplex",
    "VA": "simplex",
    "VC": "simplex",
    "XK": "simplex",
    // TRANSAK
    "AO": "transak",
    "BB": "transak",
    "BJ": "transak",
    "BQ": "transak",
    "BZ": "transak",
    "CA": "transak",
    "CG": "transak",
    "CI": "transak",
    "CL": "transak",
    "CM": "transak",
    "CO": "transak",
    "CR": "transak",
    "DE": "transak",
    "EG": "transak",
    "GF": "transak",
    "GG": "transak",
    "GI": "transak",
    "GL": "transak",
    "GN": "transak",
    "GP": "transak",
    "GW": "transak",
    "HN": "transak",
    "HT": "transak",
    "HU": "transak",
    "IN": "transak",
    "IS": "transak",
    "KG": "transak",
    "KI": "transak",
    "KN": "transak",
    "KY": "transak",
    "LB": "transak",
    "LS": "transak",
    "LU": "transak",
    "MA": "transak",
    "MC": "transak",
    "MG": "transak",
    "MX": "transak",
    "MY": "transak",
    "NI": "transak",
    "PA": "transak",
    "PH": "transak",
    "PR": "transak",
    "RE": "transak",
    "RO": "transak",
    "SE": "transak",
    "SG": "transak",
    "TC": "transak",
    "TF": "transak",
    "TJ": "transak",
    "US": "transak",
    "VE": "transak",
};
exports.PRIORITY_COUNTRIES_SELL = {
    "DEFAULT": DEFAULT_SELL_PROVIDER,
    // MERCURYO
    "AD": "mercuryo",
    "AE": "mercuryo",
    "AI": "mercuryo",
    "AW": "mercuryo",
    "AX": "mercuryo",
    "BB": "mercuryo",
    "BE": "mercuryo",
    "BM": "mercuryo",
    "BS": "mercuryo",
    "BZ": "mercuryo",
    "CH": "mercuryo",
    "DK": "mercuryo",
    "FI": "mercuryo",
    "FR": "mercuryo",
    "GE": "mercuryo",
    "GY": "mercuryo",
    "IT": "mercuryo",
    "JP": "mercuryo",
    "LT": "mercuryo",
    "NA": "mercuryo",
    "NE": "mercuryo",
    "NZ": "mercuryo",
    "OM": "mercuryo",
    "QA": "mercuryo",
    "SI": "mercuryo",
    "SK": "mercuryo",
    "ZA": "mercuryo",
    // MOONPAY
    "AG": "moonpay",
    "AM": "moonpay",
    "AR": "moonpay",
    "AT": "moonpay",
    "AU": "moonpay",
    "AZ": "moonpay",
    "BA": "moonpay",
    "BF": "moonpay",
    "BH": "moonpay",
    "BI": "moonpay",
    "BJ": "moonpay",
    "BQ": "moonpay",
    "BR": "moonpay",
    "BV": "moonpay",
    "BW": "moonpay",
    "CA": "moonpay",
    "CI": "moonpay",
    "CL": "moonpay",
    "CM": "moonpay",
    "CR": "moonpay",
    "CV": "moonpay",
    "CY": "moonpay",
    "CZ": "moonpay",
    "DE": "moonpay",
    "DM": "moonpay",
    "DO": "moonpay",
    "DZ": "moonpay",
    "EE": "moonpay",
    "EG": "moonpay",
    "ES": "moonpay",
    "ET": "moonpay",
    "FJ": "moonpay",
    "FM": "moonpay",
    "GA": "moonpay",
    "GB": "moonpay",
    "GM": "moonpay",
    "GQ": "moonpay",
    "GR": "moonpay",
    "GT": "moonpay",
    "HK": "moonpay",
    "HN": "moonpay",
    "HR": "moonpay",
    "HU": "moonpay",
    "ID": "moonpay",
    "IE": "moonpay",
    "IL": "moonpay",
    "IN": "moonpay",
    "IO": "moonpay",
    "JO": "moonpay",
    "KE": "moonpay",
    "KG": "moonpay",
    "KN": "moonpay",
    "KW": "moonpay",
    "KZ": "moonpay",
    "LA": "moonpay",
    "LB": "moonpay",
    "LC": "moonpay",
    "LI": "moonpay",
    "LK": "moonpay",
    "LS": "moonpay",
    "LU": "moonpay",
    "MC": "moonpay",
    "MD": "moonpay",
    "ME": "moonpay",
    "MR": "moonpay",
    "MV": "moonpay",
    "MW": "moonpay",
    "MX": "moonpay",
    "MZ": "moonpay",
    "NO": "moonpay",
    "PT": "moonpay",
    "PY": "moonpay",
    "RO": "moonpay",
    "SA": "moonpay",
    "SE": "moonpay",
    "SG": "moonpay",
    "SM": "moonpay",
    "SV": "moonpay",
    "TH": "moonpay",
    "TM": "moonpay",
    "TR": "moonpay",
    "TZ": "moonpay",
    "US": "moonpay",
    "UY": "moonpay",
    "UZ": "moonpay",
    "VA": "moonpay",
    "ZM": "moonpay",
    // TRANSAK
    "BL": "transak",
    "GF": "transak",
    "GP": "transak",
    "IS": "transak",
    "LV": "transak",
    "MF": "transak",
    "MQ": "transak",
    "MT": "transak",
    "NL": "transak",
    "PL": "transak",
    "PM": "transak",
    "RE": "transak",
    "XK": "transak",
    "YT": "transak"
};
//# sourceMappingURL=priorities.js.map